export const E_TEXTS_WARNINGS = {
    UNSAVED_CHANGES: "Есть несохраненные изменения!"
};


const COMMON_TEXTS = {
  NAME_FIELD: "Название",
  DESCR_FIELD: "Описание",

  REWARDS: "Награда",
  RESTRICTIONS: "Минимальные требования (ВСЕ)",
  TIME_PARAMS: "Аттрибуты времени",

  PRICE: "Цена",
  SPENDINGS: "Затраты",
  ADD: "Добавить"
};


export const UI_TEXTS = {
  /* формы поиска */

  /* временные параметры, например в квесте */
  TIME_PARAMS_TIMEOUT: "Таймаут",
  TIME_PARAMS_COOLDOWN: "Кулдаун",
  TIME_PARAMS_PREVIEW: "Превью",
  TIME_PARAMS_START: "Дата старта",
  TIME_PARAMS_END: "Дата окончания",

  /* выпадающий список для выбора типа рестрикшена */
  RESTRICTIONS_SELECT_LABEL: "Рестрикшен",

  /* */
  CONDITION_TYPE:1,


  Q_NAME: COMMON_TEXTS.NAME_FIELD,
  Q_DESCR: COMMON_TEXTS.DESCR_FIELD,
  Q_TIME_PARAMS: "Временный квест",
  Q_RESTRICTIONS: COMMON_TEXTS.RESTRICTIONS,
  Q_REWARDS: COMMON_TEXTS.REWARDS,
  Q_STAGES_HEADER: "Стадии квеста",
  Q_STAGE_NAME: COMMON_TEXTS.NAME_FIELD,
  // Q_STAGE_DESCR: COMMON_TEXTS.DESCR_FIELD,
  Q_STAGE_COND_VALUE: "Количество условия",
  Q_STAGE_COND_TYPE: "Условие",
  Q_STAGE_SKIP_PRICE: "Стоимость пропуска",
  Q_CAN_BE_ASKED: "Можно попросить",

  STRY_ONE_TIME: "Одноразовое",
  STRY_ADD: COMMON_TEXTS.ADD,
  STRY_RESTRICTIONS: COMMON_TEXTS.RESTRICTIONS,
  STRY_SCENES: "Сцены",
  STRY_TYPE: "Тип",
  STRY_DELAY: "Задержка",
  STRY_TALKS: "Реплики",
  STRY_TALK: "Реплика",
  STRY_LEFT_CHAR: "Персонаж слева",
  STRY_LEFT_CHAR_SPEAKS: "Говорит персонаж слева",
  STRY_RIGHT_CHAR: "Персонаж справа",
  STRY_EMOTION: "Эмоция",
  STRY_DIALOG_REWARD: "Награда",

  OFR_NAME: COMMON_TEXTS.NAME_FIELD,
  OFR_DESCR: COMMON_TEXTS.DESCR_FIELD,
  OFR_PRICE: "Стоимость",
  OFR_DISCOUNT: "Скидка",
  OFR_ONE_TIME_PURCHASE: "Одноразовое предложение",
  OFR_TIME_PARAMS: COMMON_TEXTS.TIME_PARAMS,
  OFR_RESTRICTIONS: COMMON_TEXTS.RESTRICTIONS,
  OFR_REWARD: COMMON_TEXTS.REWARDS,

  PREM_LOTS_NAME: COMMON_TEXTS.NAME_FIELD,
  PREM_LOTS_VIP_XP: "ВИП опыт",
  PREM_LOTS_PRICE: COMMON_TEXTS.PRICE,
  PREM_LOTS_TOTAL_AMNT: "Количество",
  PREM_LOTS_RES_ID: "Предмет",
  PREM_LOTS_CURRENCY: "Валюта",
  PREM_LOTS_HIT_TYPE: "Ленточка",

  PREM_LVLS_MAX_XP: "Опыта на уровне",
  PREM_LVLS_REWARDS: COMMON_TEXTS.REWARDS,

  ACH_NAME: COMMON_TEXTS.NAME_FIELD,
  ACH_DESCR: COMMON_TEXTS.DESCR_FIELD,
  ACH_COND: "Условие",
  ACH_STAGES: "Стадии",
  ACH_STAGE_NAME: COMMON_TEXTS.NAME_FIELD,
  ACH_STAGE_DESCR: COMMON_TEXTS.DESCR_FIELD,
  ACH_STAGE_COND_VALUE: "Количество условия?",
  ACH_STAGE_REWARDS: COMMON_TEXTS.REWARDS,

  SPLS_ID: "ID",
  SPLS_NAME: COMMON_TEXTS.NAME_FIELD,
  SPLS_DESCR: COMMON_TEXTS.DESCR_FIELD,
  SPLS_POWER: "Мощь",
  SPLS_RANGE: "Радиус",
  SPLS_SPAWN_SET: "Сет",
  SPLS_RESTRICTIONS: COMMON_TEXTS.RESTRICTIONS,
  SPLS_REWARDS: COMMON_TEXTS.REWARDS,

  BFS_NAME: COMMON_TEXTS.NAME_FIELD,
  BFS_DESCR: COMMON_TEXTS.DESCR_FIELD,
  BFS_RESTRICTIONS: COMMON_TEXTS.RESTRICTIONS,
  BFS_PRICE: "Затраты ресурсов",
  BFS_MODIFIER: "Модификатор",
  BFS_MOD_SELECT: "Модификатор",
  BFS_MOD_STR: "Мощность",
  BFS_MOD_SRC: "Источник",
  BFS_TIME_PARAMS: COMMON_TEXTS.TIME_PARAMS,

  MAP_NAME: COMMON_TEXTS.NAME_FIELD,
  MAP_SECTORS: "Секторы",
  MAP_WIDTH: "Ширина",
  MAP_HEIGHT: "Высота",
  MAP_SEC_ID: "ID сектора",
  MAP_SEC_NAME: "Название сектора",
  MAP_SEC_RESTRICTIONS: COMMON_TEXTS.RESTRICTIONS,
  MAP_SEC_PRICE: "Цена разблокировки",

  /* генераторы */
  G_TITLE: "Настройки генераторов",
  G_GARB: "Генератор мусора",
  G_GARB_PERIOD: "Период",
  G_GARB_SCATTER: "Разброс",
  G_GARB_MAX_CNT: "Макс. кол-во",
  G_GARB_MAX_DEN: "Макс. плотность",
  G_GARB_SET_TITLE: "Набор #",
  G_GARB_SET_NAME: COMMON_TEXTS.NAME_FIELD,
  G_GARB_SET_MIN_LVL: "Мин. лвл",
  G_GARB_SET_CATEGORIES: "Категории",
  G_GARB_SET_CATEGORY: "Категории #",
  G_GARB_SET_COUNTERS: "Счетчики",

  G_NUT: "Генератор Орехов",
  G_NUT_PERIOD: "Период",
  G_NUT_SCATTER: "Разброс",

  ATTR_LVL_MAX_XP: "Макс. опыта",
  ATTR_LVL_MAX_FARM: "Макс. грядок",
  ATTR_LVL_MAX_NUT: "Макс. орехов",
  ATTR_LVL_ORD: "Рынки и Вендоры",
  ATTR_LVL_MIN_PWR: "Мин. мощность",
  ATTR_LVL_MAX_PWR: "Макс. мощность",
  ATTR_LVL_SLOT_CNT: "Слоты рынка",
  ATTR_LVL_ZEP_CNT: "Слоты дирижабля",
  ATTR_LVL_REWARDS: COMMON_TEXTS.REWARDS,
  ATTR_LVL_LRG: "Награды в лотерее", /* lotteryRewardGroups */
  ATTR_LVL_LRG_WORTH: "Ценность",
  ATTR_LVL_LRG_OPTS: "Варианты наград",
  ATTR_LVL_LRG_OPT: "Награда",

  ATTR_DRP_CNT: "Количество",
  ATTR_DRP_TRIGGERS: "Триггеры",
  ATTR_DRP_ELEMS: "Элементы",
  ATTR_DRP_ELEM_ONE_ITEM: "Один айтем?",
  ATTR_DRP_ELEM_CHANCE: "Вероятность",
  ATTR_DRP_ELEM_CNT: "Количество",
  ATTR_DRP_ELEM_RES_ID: "ID ресурса",
  ATTR_DRP_RESTRICTIONS: COMMON_TEXTS.RESTRICTIONS,

  ATTR_TAB_PROFILE: "Атрибуты профиля",
  ATTR_TAB_DAILIES: "Настройки Дэйли-квестов",
  ATTR_TAB_DAILY_BONUSES: "Настройки Дэйли-бонусов",
  ATTR_TAB_ZEPPELIN: "Настройки Дирижабля",
  ATTR_TAB_SHOP: "Настройки Рынка",
  ATTR_TAB_CAMPING: "Настройки Кемпинга",
  ATTR_TAB_NUTS: "Настройки Орехов",

  ATTR_TAB_DAILY_BONUSES_DAY: "День",
  ATTR_TAB_DAILY_BONUSES_REWARD: COMMON_TEXTS.REWARDS,


  /* Аттрибуты -> Профиля и т.д. */
  ATTR_ZEP_BASE: "Базовые очки",
  ATTR_ZEP_PER_MIN: "Кубков в минуту",
  ATTR_ZEP_RATIO: "Коэф. за заказ",
  ATTR_ZEP_POWER: "Коэф. мощности",
  ATTR_ZEP_REWARD_RATIO: "Коэф. награды",
  ATTR_ZEP_SKIP_PRICE: "Стоимость скипа КД", // skipCost
  ATTR_ZEP_CD_TIME: "КД", // cooldownTime
  ATTR_ZEP_LIFETIME: "Лайфтайм",
  ATTR_ZEP_RESTRICTIONS: COMMON_TEXTS.RESTRICTIONS,

  ATTR_PROFILE_CUP: "Настройки кубков",
  ATTR_PROFILE_CUP_BASE: "Базовые очки",
  ATTR_PROFILE_CUP_PER_MIN: "Кубков в минуту",
  ATTR_PROFILE_LOC: "Настройки локации",
  ATTR_PROFILE_LOC_MAP: "Карта",

  ATTR_PROFILE_DAILY: "Настройки дейликов",
  ATTR_DAILIES_RATIO: "Коэффициент", // powerIncKoeff
  ATTR_DAILIES_POWER: "Коэф. мощности", // powerKoeff
  ATTR_DAILIES_REWARD_RATIO: "Коэф. награды", // rewardKoeff
  ATTR_DAILIES_REWARD_RND_MIN: "Мин. шанс награды", // rewardRandomMin
  ATTR_DAILIES_REWARD_RND_MAX: "Макс. шанс награды", // rewardRandomMax
  ATTR_DAILIES_STAGE_SKIP_PRICE: "Стоимость пропуска", // skipCost
  ATTR_DAILIES_RESTRICTIONS: COMMON_TEXTS.RESTRICTIONS,

  ATTR_MRK: "Настройки рынка",
  ATTR_MRK_GOLD_TO_EXP_MIN: "Золото % мин",
  ATTR_MRK_GOLD_TO_EXP_MAX: "Золото % макс",
  ATTR_MRK_PROF_RATIO: "Супер-профит коэф",
  ATTR_MRK_PROF_CHANCE: "Супер-профит шанс",

  ATTR_MRK_POWER: "Коэф. мощности",
  ATTR_MRK_REWARD_RATIO: "Коэф. награды",
  ATTR_MRK_SKIP_COST: "Стоимость скипа КД",
  ATTR_MRK_CD_LIFETIME: "Время КД",
  ATTR_MRK_RESTRICTIONS: COMMON_TEXTS.RESTRICTIONS,

  ATTR_MRK_TEMPL: "Шаблон",
  ATTR_MRK_TEMPL_NAME: COMMON_TEXTS.NAME_FIELD,
  ATTR_MRK_TEMPL_MIN: "Мин. предметов",
  ATTR_MRK_TEMPL_MAX: "Макс. предметов",
  ATTR_MRK_TEMPL_PWR_RATIO: "Коэф. мощности?",
  ATTR_MRK_TEMPL_CHANCE: "Шанс выпадения",
  ATTR_MRK_TEMPL_MIN_LVL: "Ур. анлока",
  ATTR_MRK_TEMPL_SUPR_PROF_CHANCE: "Шанс супер-профита?",
  ATTR_MRK_TEMPL_SUPR_PROF_RATIO: "Коэфф супер-профита?",



  ATTR_NUT: "nutConfig?",
  ATTR_NUT_BLD_ATCK_COOLDOWN: "Кулдаун атаки здания",
  ATTR_NUT_SHM_ATCK_COOLDOWN: "Кулдаун атаки шму",
  ATTR_NUT_ANIM_ATCK_COOLDOWN: "Кулдаун атаки животн.",
  ATTR_NUT_MAX_BROKEN_BLD: "Макс сломанных построек",
  ATTR_NUT_RATIO_BROKEN_BDL: "Коэф. сломанных построек",

  GO_NAME: COMMON_TEXTS.NAME_FIELD,
  GO_DESCR: COMMON_TEXTS.DESCR_FIELD,

  GO_FLT_COST: "Изменяющаяся цена",
  GO_FLT_COST_RESTRICTIONS: COMMON_TEXTS.RESTRICTIONS,
  GO_FLT_COST_PRICE: COMMON_TEXTS.SPENDINGS,

  GO_WRK: "Настройки производства",
  GO_WRK_UPGR: "Апгрейды",
  GO_WRK_REP: "Ремонт",
  GO_WRK_ACT: "Производства",

  GO_WRK_ACTION_TYPE: "Тип действия",
  GO_WRK_ACTION_ACC_PRICE: "Стоимость ускорения",
  GO_WRK_ACTION_TIME: "Время",
  GO_WRK_ACTION_WORKERS: "Кол-во рабочих",
  GO_WRK_ACTION_RESTRICTIONS: COMMON_TEXTS.RESTRICTIONS,
  GO_WRK_ACTION_PRICE: COMMON_TEXTS.SPENDINGS,
  GO_WRK_ACTION_REWARDS: COMMON_TEXTS.REWARDS,

  GO_WRK_FREE_SLOTS: "Бесплатные слоты",
  GO_WRK_PROD_Q_SLOTS: "Слоты производства",

  GO_PLANT: "Атрибуты растения",

  GO_BND: "Размер",
  GO_BND_WIDTH: "Ширина",
  GO_BND_HEIGHT: "Высота",

  GO_LAIR: "Атрибуты логова",
  GO_LAIR_PERIOD: "Период",

  GO_LIM: "Атрибуты лимитов",
  GO_LIM_L: "Предел",

  GO_INIT: "Начальный компонент",
  GO_INIT_LVL: "Уровень",

  GO_SHOP: "Атрибуты каталога",
  GO_SHOP_CAT: "Категория",

  GO_STORAGE: "Атрибуты хранилища",
  GO_STORAGE_LIM: "Пределы",

  GO_PASTURE: "Атрибуты пастбища",
  GO_PASTURE_ANML_ID: "ID животного",
  GO_PASTURE_RUN_SPD: "Скорость бега",
  GO_PASTURE_REG_RAD: "Радиус пастбища",
  GO_PASTURE_ANIM_SPD_RATIO: "Коэф. скорости",
  GO_PASTURE_WLK_SPD: "Скорость шага",
  GO_PASTURE_ANML_LIMITS: "Макс. животных",

  GO_RES: "Атрибуты ресурса",
  GO_RES_STRG_CAT: "Категория хранилища",
  GO_RES_DEEP: "Глубина",
  GO_RES_STORABLE: "Можно хранить",
  GO_RES_XP: "Опыт",
  GO_RES_WEIGHT: "Вес",
  GO_RES_MRKT_PRICE_CUSTOM: "Ст. на рынке (кастом)",
  GO_RES_WGHT_CUSTOM: "Вес (кастом)",
  GO_DAILY_MAX: "Максимум в день",
  GO_RES_SELL_PRICE: "Ст. в хранилище",
  GO_RES_OWNER_ID: "ownerId",
  GO_RES_SKIP_PRICE: "Стоимость скипа",
  GO_RES_SOURCE: "source",

  GO_DECOR: "Атрибуты влияния",
  GO_DECOR_MOD: "Модификатор",
  GO_DECOR_STR: "Мощность",
  GO_DECOR_OUT_MOD_RAD: "Радиус действия",

  GO_RES_TRAN: "Покупка",
  GO_RES_TRAN_RESTRICTIONS: COMMON_TEXTS.RESTRICTIONS,
  GO_RES_TRAN_SHOP_PRC: "Стоимость в магазине",
  GO_RES_TRAN_REWARDS: COMMON_TEXTS.REWARDS,

  GO_HOUSE: "Атрибуты Жилья",
  GO_HOUSE_NUM_WRKRS: "Кол-во шму"
};



// WEBPACK FOOTER //
// /opt/app/develop/src/app/enums/e-texts.ts